// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".main-layout[data-v-a344e580]{padding-top:var(--padding-3xl)}.main-layout>*[data-v-a344e580]{margin-bottom:var(--spaces-xl)}@media(min-width:1200px){.main-layout>*[data-v-a344e580]{margin-bottom:var(--spaces-3xl)}}.bottom[data-v-a344e580]{margin-top:var(--spaces-2xl);margin-bottom:var(--spaces-2xl)}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
